import * as React from 'react'
import {Link} from 'react-router-dom'
import {Button} from 'antd';
import errorImg from '../common/img/error_img.svg'

class  Authority extends React.Component{
    constructor(props) {
      super()
    }
    render(){
        return(
            <div className='errorPage' style={{paddingTop:50}}>
            <img src={errorImg} alt=""/>
                <div>
                    <h3>无访问权限......</h3>
                    <Link to='/homePage'>
                        <span>返回首页</span>
                    </Link>
                </div>
        </div>
        )
    }

    }
export default Authority